import React from "react";

import { InjectedFormProps } from "redux-form";

import { Grid, TextField, Button } from "material-ui";
import logger from "../../../../util/logger";

import OP from "./op.png";
import Aktia from "./aktia.png";
import Alandsbanken from "./alands.png";
import Handelsbanken from "./handels.png";
import SPankki from "./spankki.png";
import Nordea from "./nordea.png";
import Pop from "./pop.png";
import Danske from "./danskebank.png";
import OmaSP from "./omasp.png";
import SP from "./sp.png";
import { IEIdentifyProvider } from "ducks/eidentify";

interface Common {
    id?: string;
    style?: React.CSSProperties;
    className?: string;
    label?: string;
}

export interface TupasState {
    username: string; //email
}

interface ITupasProps {
    providerData: IEIdentifyProvider[] | null;
    handleClick: (id: number) => void;
}

type TupasProps = ITupasProps & InjectedFormProps<TupasState, ITupasProps>;
const getImage = (id: number) => {
    switch (id) {
        case 1:
            return Nordea;
        case 2:
            return OP;
        case 3:
            return Aktia;
        case 4:
            return Handelsbanken;
        case 5:
            return SPankki;
        case 6:
            return Pop;
        case 7:
            return Danske;
        case 8:
            return Alandsbanken;
        case 9:
            return OmaSP;
        case 10:
            return SP;
        default:
            return OP;
    }
};

export const Banks: React.SFC<ITupasProps> = (props) => {
    const { providerData } = props;

    return (
        <div>
            <Grid container spacing={0}>
                {providerData &&
                    providerData.map((el: IEIdentifyProvider) => {
                        return (
                            <Grid item xs={4} sm={4} key={el.id}>
                                <div>
                                    <div className="tupasBox">
                                        <div
                                            className="tupasImage"
                                            onClick={() =>
                                                props.handleClick(el.id)
                                            }
                                        >
                                            <input
                                                type="image"
                                                src={getImage(el.id)}
                                                alt={el.name}
                                            />
                                        </div>
                                        <div className="tupasName">
                                            <p>{el.name}</p>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        );
                    })}
            </Grid>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/eidentify/components/Banks/Banks.tsx